<template>
  <div class="container">
    <van-sticky>
      <!-- 顶部 -->
      <div class="top">
        <div class="left">
          <span :class="typeIndex == 0 ? 'active' : ''" @click="onChangeType(0)">{{ $t('asset').Overview }}</span>
          <span :class="typeIndex == 1 ? 'active' : ''" @click="onChangeType(1)">{{ $t('asset').contract }}</span>
          <span :class="typeIndex == 2 ? 'active' : ''" @click="onChangeType(2)">{{ $t('public').spot }}</span>
          <span :class="typeIndex == 3 ? 'active' : ''" @click="onChangeType(3)">{{ $t('asset').wallet }}</span>
          <span :class="typeIndex == 4 ? 'active' : ''" @click="onChangeType(4)">{{ $t('tabBar').heel }}</span>
        </div>
        <svg-icon class-name="svgs" icon-class="position" @click="$router.push({ name: 'Bill' })" />
      </div>
    </van-sticky>
    <!-- 总览 -->
    <div class="totalInfo" v-if="typeIndex == 0">
      <!-- 总资产估值 -->
      <div class="tit">
        <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
        <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
        <span>{{ $t('asset').Totalassetvaluation }}</span>
      </div>
      <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
      <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
      <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
      <div class="ynum" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
      <div class="ico"> <svg-icon class-name="svgs" icon-class="deposit" /></div>
      <div class="lable">{{ $t('asset').supportswithdrawal }}</div>
      <!-- 充值 -->
      <div class="btn" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
      <div class="line"></div>
      <!-- 合约账户 -->
      <div class="item" @click="onChangeType(1)">
        <div class="left">{{ $t('asset').Contractaccount }}</div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_contract }} USDT
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_contract }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div>
      <!-- 现货账户 -->
      <div class="item" @click="onChangeType(2)">
        <div class="left">{{ $t('asset').Spotaccount }}</div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_coin }} USDT
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_coin }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div>
      <!-- 钱包账户 -->
      <div class="item" @click="onChangeType(3)">
        <div class="left">{{ $t('asset').Walletaccount }}</div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_wallet }} USDT
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_wallet }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div>
      <!-- 理财账户 -->
      <div class="item" @click="onChangeType(4)">
        <div class="left">{{ $t('finance').financeAccount }}</div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_finance }} USDT
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_finance }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div>
    </div>
    <!-- 合约 -->
    <div class="contractInfo" v-if="typeIndex == 1">
      <div class="tit">
        <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
        <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
        <span>{{ $t('asset').ValuationContractAssets }}</span>
      </div>
      <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
      <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
      <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
      <div class="ynum" v-else>*****{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
      <!-- 盈亏 -->
      <div class="pnum" v-if="isShow">{{ $t('asset').profitloss }}<span>{{ propertyVo.profitTotalAmount }}
          USDT</span>≈USD${{
            propertyVo.profitTotalAmount }}</div>
      <div class="pnum" v-else>{{ $t('asset').profitloss }}<span>{{
        propertyVo.profitTotalAmount.toString().replace(/./g, '*') }}
          ****</span>*****{{
            propertyVo.profitTotalAmount.toString().replace(/./g, '*') }} </div>
      <div class="btns">
        <!-- 充值 -->
        <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
        <!-- 划转 -->
        <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 1 } })">{{ $t('asset').Transfer }}
        </div>
      </div>
      <div class="line"></div>
      <!-- USDT合约 -->
      <div class="lable">{{ $t('public').USDTcontract }}</div>
      <div class="item">
        <div class="left"> <img class="img" src="@/assets/img/USDT.png" /><span>USDT</span></div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_usdt }}
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_usdt }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div>
      <!-- 盈亏占用可用 -->
      <div class="itm1"><span>{{ $t('asset').profitloss }}</span><span>{{ $t('asset').occupy }}</span><span>{{
        $t('asset').available }}</span></div>
      <div class="itm2"><span>{{ propertyVo.profitAmount_usdt }}</span><span>{{ propertyVo.useAmount_usdt
          }}</span><span>{{ propertyVo.amount_usdt }}</span></div>
      <div class="itm3" @click="$router.push({ name: 'Position' })"><span>{{ $t('asset').Viewallpositions
      }}</span><van-icon name="arrow" color="var(--text_color)" size="13" /></div>
      <!-- 法币合约 -->
      <!-- <div class="lable">{{ $t('public').Fiatcurrencycontract }}</div>
      <div class="item">
        <div class="left">
          <div class="img2">$</div><span>USD</span>
        </div>
        <div class="right">
          <div class="rr">
            <div class="r1">{{ propertyVo.totalAMount_legal }}
            </div>
            <div class="r2">≈USD${{ propertyVo.totalAMount_legal }}</div>
          </div>
          <van-icon name="arrow" color="var(--ntext_color)" size="13" />
        </div>
      </div> -->
      <!-- 盈亏占用可用 -->
      <!-- <div class="itm1"><span>{{ $t('asset').profitloss }}</span><span>{{ $t('asset').occupy }}</span><span>{{
        $t('asset').available }}</span></div>
      <div class="itm2"><span>{{ propertyVo.profitAmount_legal }}</span><span>{{ propertyVo.useAmount_legal
          }}</span><span>{{ propertyVo.amount_legal }}</span></div>
      <div class="itm3" @click="$router.push({ name: 'Position' })"><span>{{ $t('asset').Viewallpositions
      }}</span><van-icon name="arrow" color="var(--text_color)" size="13" /></div> -->
    </div>
    <!-- 现货 -->
    <div class="coinInfo" v-if="typeIndex == 2">
      <!-- 现货资产估值 -->
      <div class="tit">
        <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
        <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
        <span>{{ $t('asset').Valuationspotassets }}</span>
      </div>
      <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
      <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
      <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
      <div class="ynum" v-else>*****{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
      <div class="btns">
        <!-- 充值 -->
        <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
        <!-- 闪兑 -->
        <div class="t2" @click="$router.push({ name: 'AssetFlashcash', query: { t: 3 } })">{{ $t('asset').flashcash }}
        </div>
        <!-- 划转 -->
        <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 3 } })">{{ $t('asset').Transfer }}
        </div>
      </div>
      <div class="line"></div>
      <!-- 隐藏零余额资产 -->
      <div class="lable" @click="isHideZero = !isHideZero"><van-checkbox icon-size="12" v-model="isHideZero" checked-color="var(--primary_color)" shape="square"></van-checkbox><span> {{ $t('asset').Hidezerobalanceassets
          }}</span></div>
      <div class="item" v-for="(dItem, dIndex) in propertyVo.propertyList" :key="`coin${dIndex}`">
        <div v-if="!isHideZero || dItem.totalAmount > 0" @click="toFlashcash(3, dItem.currency)">
          <div class="itmtop">
            <div class="left">
              <img class="img" src="@/assets/img/USDT.png" v-if="dItem.currency == 'USDT'" />
              <img class="img" :src="baseUrl + dItem.logoUrl" v-else />
              <div class="rr" style="text-align: left;">
                <div class="r1">{{ dItem.currency }}
                </div>
                <div class="r2">{{ $t('asset').balance }}</div>
              </div>
            </div>
            <div class="right">
              <div class="rr">
                <div class="r1">{{ dItem.totalAmount }}
                </div>
                <div class="r2">≈USD${{ dItem.usdtAmount }}</div>
              </div>
              <van-icon name="arrow" color="var(--ntext_color)" size="13" />
            </div>
          </div>
          <!-- 占用可用 -->
          <div class="itm1"><span>{{ $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span></div>
          <div class="itm2"><span>{{ dItem.useAmount }}</span><span>{{ dItem.amount }}</span></div>
        </div>
      </div>
    </div>
    <!-- 钱包 -->
    <div class="walletInfo" v-if="typeIndex == 3">
      <!-- 钱包资产估值 -->
      <div class="tit">
        <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
        <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
        <span>{{ $t('asset').ValuationWalletAssets }}</span>
      </div>
      <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
      <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
      <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
      <div class="ynum" v-else>*****{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
      <div class="btns">
        <!-- 充值 -->
        <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
        <!-- 闪兑 -->
        <div class="t2" @click="$router.push({ name: 'AssetFlashcash', query: { t: 4 } })">{{ $t('asset').flashcash }}
        </div>
        <!-- 划转 -->
        <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { f: 3, t: 4 } })">{{ $t('asset').Transfer
        }}</div>
        <!-- 提现 -->
        <div class="t2" @click="$router.push({ name: 'WithCurrency' })" v-if="!$store.state.isSim">{{ $t('asset').Withdrawal }}</div>
      </div>
      <div class="line"></div>
      <!-- 隐藏零余额资产 -->
      <div class="lable" @click="isHideZero = !isHideZero"><van-checkbox icon-size="12" v-model="isHideZero" checked-color="var(--primary_color)" shape="square"></van-checkbox><span> {{ $t('asset').Hidezerobalanceassets
          }}</span></div>
      <div v-for="(dItem, dIndex) in propertyVo.propertyList" :key="`wallet${dIndex}`">
        <div class="item" v-if="!isHideZero || dItem.totalAmount > 0" @click="toFlashcash(4, dItem.currency)">
          <div class="itmtop">
            <div class="left">
              <img class="img" :src="require(`@/assets/img/${dItem.currency}.png`)" />
              <div class="rr" style="text-align: left;">
                <div class="r1">{{ dItem.currency }}
                </div>
                <div class="r2">{{ $t('asset').Walletbalance }}</div>
              </div>
            </div>
            <div class="right">
              <div class="rr">
                <div class="r1">{{ dItem.totalAmount }}
                </div>
                <div class="r2">≈USD${{ dItem.usdtAmount }}</div>
              </div>
              <van-icon name="arrow" color="var(--ntext_color)" size="13" />
            </div>
          </div>
          <!-- 占用可用 -->
          <div class="itm1"><span>{{ $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span></div>
          <div class="itm2"><span>{{ dItem.useAmount }}</span><span>{{ dItem.amount }}</span></div>
        </div>
      </div>
    </div>
    <!-- 理财 -->
    <div class="financeInfo" v-if="typeIndex == 4">
      <!-- 理财资产估值 -->
      <div class="tit">
        <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
        <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
        <span>{{ $t('finance').financeAssetAmount }}</span>
      </div>
      <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
      <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
      <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
      <div class="ynum" v-else>*****{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
      <div class="btns">
        <!-- 充值 -->
        <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
        <!-- 划转 -->
        <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 5 } })">{{ $t('asset').Transfer }}
        </div>
      </div>
      <div class="line"></div>
      <div class="item">
        <div class="itmtop">
          <div class="left">
            <img class="img" src="@/assets/img/USDT.png" />
            <div class="rr" style="text-align: left;">
              <div class="r1">USDT
              </div>
              <div class="r2">{{ $t('asset').balance }}</div>
            </div>
          </div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAmount }}
              </div>
              <div class="r2">≈USD${{ propertyVo.usdtAmount }}</div>
            </div>
            <van-icon name="arrow" color="var(--ntext_color)" size="13" />
          </div>
        </div>
        <!-- 占用可用 -->
        <div class="itm1"><span>{{ $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span></div>
        <div class="itm2"><span>{{ propertyVo.useAmount }}</span><span>{{ propertyVo.amount }}</span></div>
        <div class="itm3" @click="$router.push({ name: 'FinanceList' })"><span>{{ $t('asset').Viewallpositions
        }}</span><van-icon name="arrow" color="var(--text_color)" size="13" /></div>
      </div>
    </div>
    <!-- 充值选择 -->
    <van-popup v-model="showRechargeSelect" position="bottom" closeable>
      <div class="rechargeSelInfo">
        <div class="tit">{{ $t('asset').Recharge }}</div>
        <div class="tabs" @click="$goRecharge('RechargeCurrency')">{{ $t('asset').Cryptocurrencyrecharge }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$goRecharge('Recharge')">{{ $t('asset').Fiatcurrencyrecharge
        }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
    <TabBar active="Asset" />
  </div>
</template>

<script>
import userApi from '@/api/user'
import TabBar from '@/components/tabBar'
import PublicHeader from '@/components/publicHeader'
import onShowMixin from '@/mixins/onShow.js';

export default {
  mixins: [onShowMixin],
  components: {
    TabBar,
    PublicHeader
  },
  data() {
    return {
      baseUrl: window.baseURL,
      isHideZero: false,
      showRechargeSelect: false,
      isShow: true,
      typeIndex: 0,
      propertyVo: {}
    }
  },
  mounted() {
    // this.getPropertyInfo()
  },
  //页面被缓存后重新显示
  activated() {
    this.getPropertyInfo()
  },
  methods: {
    onShow() {
      this.getPropertyInfo()
    },
    onChangeType(val) {
      this.typeIndex = val
      this.getPropertyInfo()
    },
    //跳转闪兑
    toFlashcash(t, b) {
      // if (b == 'USDT')
      //   this.$router.push({ name: 'AssetFlashcash', query: { t, b: null } })
      // else
      this.$router.push({ name: 'AssetFlashcash', query: { t, b } })
    },
    //获取资产统计
    async getPropertyInfo() {
      this.propertyVo = {}
      const res = await userApi.getPropertyInfo({ type: this.typeIndex })
      this.propertyVo = res.data
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 75px;
  width: 100%;
  background: var(--background_color);

  .top {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: var(--background_color);

    .left {
      margin-right: -15px;
      width: 300px;
      display: flex;
      flex-wrap: wrap;
      font-weight: bold;
      font-size: 17px;
      color: var(--ntext_color);
      line-height: 25px;

      span {
        margin-right: 15px;
      }

      .active {
        color: var(--primary_color);
      }
    }

    .svgs {
      width: 17px;
      height: 17px;
      color: var(--primary_color);
    }
  }

  .totalInfo {
    padding: 15px 0;

    .tit {
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
        font-size: 14px;
        color: var(--text_color);
      }
    }

    .num {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 25px;
      font-weight: 800;
      color: var(--primary_color);

      span {
        margin-left: 5px;
        font-size: 17px;
      }
    }

    .ynum {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .ico {
      margin-top: 30px;
      text-align: center;

      .svgs {
        width: 100px;
        height: 100px;
        color: var(--primary_color);
      }
    }

    .lable {
      margin-top: 30px;
      text-align: center;
      font-weight: bold;
      font-size: 17px;
      color: var(--primary_color);
    }

    .btn {
      margin: 20px auto;
      width: 150px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #fff;
      background: var(--primary_color);
      border-radius: 18px;
    }

    .line {
      height: 7px;
      background: var(--info_color);
    }

    .item {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        font-size: 15px;
        color: var(--text_color);
        font-weight: bold;
      }

      .right {
        display: flex;
        align-items: center;

        .rr {
          margin-right: 5px;
          text-align: right;

          .r1 {
            font-size: 14px;
            color: var(--primary_color);
            font-weight: bold;
          }

          .r2 {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }
    }
  }

  .contractInfo {
    padding: 15px 0;

    .tit {
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
        font-size: 14px;
        color: var(--text_color);
      }
    }

    .num {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 25px;
      font-weight: 800;
      color: var(--primary_color);

      span {
        margin-left: 5px;
        font-size: 17px;
      }
    }

    .ynum {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .pnum {
      padding: 0 15px;
      margin-top: 20px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        margin: 0 5px;
        color: var(--primary_color);
      }
    }

    .btns {
      padding: 30px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t1 {
        width: 50%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        background: var(--primary_color);
        border-radius: 18px;
      }

      .t2 {
        margin-left: 10px;
        width: 50%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: var(--primary_color);
        background: var(--info_color);
        border-radius: 18px;
      }
    }

    .line {
      height: 7px;
      background: var(--info_color);
    }

    .lable {
      margin: 30px 15px 0 15px;
      font-size: 15px;
      color: var(--text_color);
      font-weight: bold;
    }

    .item {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }

        .img2 {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background: var(--text_color);
          color: var(--background_color);
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        span {
          font-size: 15px;
          color: var(--primary_color);
          font-weight: bold;
          margin-left: 10px;
        }
      }

      .right {
        display: flex;
        align-items: center;

        .rr {
          margin-right: 5px;
          text-align: right;

          .r1 {
            font-size: 14px;
            color: var(--primary_color);
            font-weight: bold;
          }

          .r2 {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }
    }

    .itm1 {
      margin: 5px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .itm2 {
      margin: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: var(--primary_color);
    }

    .itm3 {
      margin: 20px 15px 0 0;
      font-size: 13px;
      color: var(--text_color);
      font-weight: bold;
      text-align: right;

      span {
        margin-right: 5px;
      }
    }
  }

  .coinInfo {
    padding: 15px 0;

    .tit {
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
        font-size: 14px;
        color: var(--text_color);
      }
    }

    .num {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 25px;
      font-weight: 800;
      color: var(--primary_color);

      span {
        margin-left: 5px;
        font-size: 17px;
      }
    }

    .ynum {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .btns {
      padding: 30px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t1 {
        width: 33%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        background: var(--primary_color);
        border-radius: 18px;
      }

      .t2 {
        margin-left: 10px;
        width: 33%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: var(--primary_color);
        background: var(--info_color);
        border-radius: 18px;
      }
    }

    .line {
      height: 7px;
      background: var(--info_color);
    }

    .lable {
      margin: 15px 15px 0 15px;
      font-size: 13px;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
      }
    }

    .item {
      margin-top: 15px;

      .itmtop {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .right {
          display: flex;
          align-items: center;
        }

        .rr {
          margin-right: 5px;
          text-align: right;

          .r1 {
            font-size: 14px;
            color: var(--primary_color);
            font-weight: bold;
          }

          .r2 {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }

      .itm1 {
        margin: 0 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--ntext_color);
      }

      .itm2 {
        margin: 5px 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--primary_color);
      }
    }
  }

  .walletInfo {
    padding: 15px 0;

    .tit {
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
        font-size: 14px;
        color: var(--text_color);
      }
    }

    .num {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 25px;
      font-weight: 800;
      color: var(--primary_color);

      span {
        margin-left: 5px;
        font-size: 17px;
      }
    }

    .ynum {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .btns {
      padding: 30px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t1 {
        width: 25%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        background: var(--primary_color);
        border-radius: 18px;
      }

      .t2 {
        margin-left: 10px;
        width: 25%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: var(--primary_color);
        background: var(--info_color);
        border-radius: 18px;
      }
    }

    .line {
      height: 7px;
      background: var(--info_color);
    }

    .lable {
      margin: 15px;
      font-size: 13px;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
      }
    }

    .item {
      margin-top: 15px;

      .itmtop {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .right {
          display: flex;
          align-items: center;
        }

        .rr {
          margin-right: 5px;
          text-align: right;

          .r1 {
            font-size: 14px;
            color: var(--primary_color);
            font-weight: bold;
          }

          .r2 {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }

      .itm1 {
        margin: 0 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--ntext_color);
      }

      .itm2 {
        margin: 5px 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--primary_color);
      }
    }
  }

  .financeInfo {
    padding: 15px 0;

    .tit {
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
        font-size: 14px;
        color: var(--text_color);
      }
    }

    .num {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 25px;
      font-weight: 800;
      color: var(--primary_color);

      span {
        margin-left: 5px;
        font-size: 17px;
      }
    }

    .ynum {
      padding: 0 15px;
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }

    .btns {
      padding: 30px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t1 {
        width: 50%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        background: var(--primary_color);
        border-radius: 18px;
      }

      .t2 {
        margin-left: 10px;
        width: 50%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: var(--primary_color);
        background: var(--info_color);
        border-radius: 18px;
      }
    }

    .line {
      height: 7px;
      background: var(--info_color);
    }

    .lable {
      margin: 15px 15px 0 15px;
      font-size: 13px;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
      }
    }

    .item {
      margin-top: 15px;

      .itmtop {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .right {
          display: flex;
          align-items: center;
        }

        .rr {
          margin-right: 5px;
          text-align: right;

          .r1 {
            font-size: 14px;
            color: var(--primary_color);
            font-weight: bold;
          }

          .r2 {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }

      .itm1 {
        margin: 0 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--ntext_color);
      }

      .itm2 {
        margin: 5px 35px 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--primary_color);
      }

      .itm3 {
        margin: 20px 15px 0 0;
        font-size: 13px;
        color: var(--text_color);
        font-weight: bold;
        text-align: right;

        span {
          margin-right: 5px;
        }
      }
    }
  }

  .rechargeSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 10px 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 15px;
  color: var(--ntext_color);
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: #fff;
}
</style>
